import React, { useEffect, useRef, useState } from 'react';
import { IoMdDownload } from "react-icons/io";
import ImageOrStickerMessage from '../../other../../others/typeMessages/ImageOrStickerMessage';
import LocationOrForwardedMessage from '../../others/typeMessages/LocationOrForwardedMessage';
import ContactsOrForwardedMessage from '../../others/typeMessages/ContactsOrForwardedMessage';
import VideoOrForwardedMessage from '../../others/typeMessages/VideoOrForwardedMessage';
import DocumentOrForwardedMessage from '../../others/typeMessages/DocumentOrForwardedMessage';
import AudioOrForwardedMessage from '../../others/typeMessages/AudioOrForwardedMessage';
import TemplateMessage from '../../others/typeMessages/TemplateMessage';
import InteractiveMessage from '../../others/typeMessages/InteractiveMessage';
import OrderMessage from '../../others/typeMessages/OrderMessage';
import ContextProductMessage from '../../others/typeMessages/ContextProductMessage';
import ContextTextMessage from '../../others/typeMessages/ContextTextMessage';
import ForwardedMessage from '../../others/typeMessages/ForwardedMessage';
import AdvertisingMessage from '../../others/typeMessages/AdvertisingMessage';
import GroupedImages from '../../others/typeMessages/GroupedImages';
import WarningMessage from '../../others/typeMessages/WarningMessage';
import TransferMessage from '../../others/typeMessages/TransferMessage';
import CloseConvMessage from '../../others/typeMessages/CloseConvMessage';
import FooterMessage from '../../others/typeMessages/FooterMessage';
import ListButtonsCallToAction from '../../others/typeMessages/ListButtonsCallToAction';
import TextMessage from '../../others/typeMessages/TextMessage';
import ImageGallery from '../../others/ImageGallery';
import imgMap from "../../../imgs/img-map.png";
import { use } from 'react';
import Modal from '../../layout/Modal';
import { FaUser } from 'react-icons/fa';
import styled from 'styled-components';
import useAPI from '../../../hooks/useAPI';
import { useForm } from 'react-hook-form';
import { FaShareFromSquare } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';
import { resolveInternationalPhone } from '../../../utils/phone';

const MessageList = ({ listMessages, templates, showContactInfo, setListMessages, infoContact, isProspects = false }) => {
    const [loading, setLoading] = useState(false);
    const [isGallery, setIsGallery] = useState(false)
    const [imgSelected, setImgSelected] = useState("")
    const [viewSelectedImage, setViewSelectedImage] = useState("");
    const [videoSelected, setVideoSelected] = useState("");
    const [listImages, setListImages] = useState("")
    const [listContacts, setListContacts] = useState([])
    const [modalListContacts, setModalListContacts] = useState(false)
    const [listProducts, setListProducts] = useState([])
    const [listProducts2, setListProducts2] = useState([])
    const [listProductsTable, setListProductsTable] = useState([])
    const [productContextSelected, setProductContextSelected] = useState({});
    const [modalViewOrder, setModalViewOrder] = useState(false)
    const [quantityOrder, setQuantityOrder] = useState("")
    const [totalPriceOrder, setTotalPriceOrder] = useState("")
    const [orderSelected, setOrderSelected] = useState([])
    const [conversationsPendingCount, setConversationsPendingCount] = useState(0);
    const [conversationsAssignedCount, setConversationsAssignedCount] = useState(0);
    const [scrollPosition, setScrollPosition] = useState(0)
    
    const focusScrollMessageHeight = useRef(0);
    const messagesContainerRef = useRef(null);

    const { urlAPI_1, urlAPI_2, urlAPI_3, urlSocket, fetchWithAuth } = useAPI()

    
    const formGenerateLink = useForm()
    const error6 = formGenerateLink.formState.errors;

    const onViewGalery = async (gallery) => {
        setIsGallery(true)
        setImgSelected(gallery[0])
        setListImages(gallery)
        console.log('lista de imagenes:::', gallery)
    }

    //# Navegacion
    const navigate = useNavigate();

    // useEffect(() => {
    //     focusOnScrollMessage()
    //     console.log('infoContact: ', infoContact)
    // }, []);
    useEffect(() => {
        console.log('infoContact: ', infoContact)
    }, []);

    useEffect(() => {
        const container = messagesContainerRef.current;
        if (!container) return;

        // Scroll inmediato al montar o cuando cambian mensajes
        container.scrollTop = container.scrollHeight;

        const observer = new ResizeObserver(() => {
            container.scrollTop = container.scrollHeight;
        });

        observer.observe(container);

        return () => observer.disconnect();
    }, [listMessages]);

    //Ver imagen grande
    const onViewImage = (id) => {
        const filt = listMessages.filter((element) => element.messageId === id);
        setViewSelectedImage(filt);
        const div = document.getElementById('cont-chat');
        if (div) {
            setScrollPosition(div.scrollTop);
        }
    };

    const focusOnScrollMessage = (from_var = "default") => {
        let div = document.getElementById("content-list-message");
        if (div) {
        let offset = 40;
        div.scrollTop = div.scrollHeight - focusScrollMessageHeight.current + offset;
        }
    };

    return (
        <>
            {/* <section id='content-list-message' className="section-preview msg p-3 pt-5" style={{overflowY: "auto", height: "90%"}}> */}
            <section 
                ref={messagesContainerRef} 
                id='content-list-message' 
                className="section-preview msg p-3 pt-5" 
                style={{
                    overflowY: "auto", 
                    height: isProspects ? "90%" : "100%"
                }}
            >
                <div className="section-div1 warning" style={{ maxWidth: "80%", margin:" 0px auto 30px" }}>
                    <div id="section2-warning" className="section-div2 warning">
                        <div className="section-div3-warning">
                            <div className="section-div4">
                                <div className="text-center py-1">
                                    <span className="span f-s-italic d-flex align-items-center justify-content-center">
                                        Para ver mas mensajes, ve al panel multiagente
                                        {/* <pre className="w-100" style={{whiteSpace: "pre-wrap"}}>Para ver mas mensajes, ve al multiagente</pre> */}
                                        <FaShareFromSquare 
                                            className="ml-1 pointer" 
                                            style={{fontSize: "1.2rem"}}
                                            data-tooltip-id="my-tooltip"
                                            data-tooltip-content="Ir al panel multiagente"
                                            onClick={() => {
                                                console.log('Ir al chat del contacto desde el mensaje')
                                                navigate(`/home/chat`, { 
                                                    state: { 
                                                        parametro: resolveInternationalPhone(infoContact.callingCode, infoContact.phone),
                                                        idContact: infoContact._id,
                                                        isChat: true
                                                    } 
                                                })
                                            }}
                                            // onClick={infoContact.wpp_enabled ? () => {
                                            //     console.log('Ir al chat del contacto desde el mensaje')
                                            //     navigate(`/home/chat`, { 
                                            //         state: { 
                                            //             idContact: infoContact._id,
                                            //             isChat: true
                                            //         } 
                                            //     })
                                            // } : undefined}
                                        />
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {listMessages && listMessages.map((message, m) => {
                    var ext = "";
                    const namee = message.nameMedia;
                    if (namee) {
                        var extension = message.nameMedia.split(".")[1];
                        if (extension) {
                            ext = extension;
                        }
                    }
                    //Validamos si el tipo de mensaje para obtener y pintar su contenido
                    const typeMessage = message.bodyType;
                    var formatHeader = "";
                    var headerText = ""
                    var footerText = "";
                    var bodyTextFlow = "";
                    var bodyText = "";
                    var listButtonsCallToAction = [];
                    var listButtonsQuickReply = [];
                    var listButtonsUrlDynamic = [];
                    let imgProduct = "";
                    let numberProducts = "";
                    let linkLocation = ""
                    let nameLocation = ""
                    let linkName = ""
                    let adressLocation = ""
                    let textContacts = ""
                    let contactList = []
                    let orderShopping = []
                    let ProductInContext = {}
                    let buttonsReply = []
                    let urlAdvertising = ""
                    let typeForwarded = ""
                    let textForwarded = ""
                    let isTextError = false
                    let typeResponseUser = ""


                    if (typeMessage === "template") {
                        const idTemplatee = parseInt(message.idTemplate);
                        if (idTemplatee && templates.length > 0) {
                            const filteredTemplates = templates.filter(tem => tem.id === idTemplatee);

                            if (filteredTemplates.length > 0) {
                                //#--> Validamos que si tenga header la plantilla
                                const filterHeader = filteredTemplates[0].content.filter(tem => {if (tem.type === "HEADER") return tem});
                                if(filterHeader.length){
                                    formatHeader = filterHeader[0].format;
                                    headerText = filterHeader[0].text;
                                }

                                //#--> Validamos el Body de la plantilla
                                const filterBody = filteredTemplates[0].content.filter(tem => {if (tem.type === "BODY") return tem})
                                bodyText = filterBody[0].text;
                                if(filterBody.length){
                                    bodyText = filterBody[0].text;
                                }
                                //#--> Validamos que si tenga footer la plantilla
                                const contentFooter = filteredTemplates[0].content.filter(tem => {if (tem.type === "FOOTER") return tem})
                                footerText = contentFooter;

                                //#--> Validamos que si tenga botones la plantilla selecionada
                                const filterButtons = filteredTemplates[0].content.filter(tem => {if (tem.type === "BUTTONS") return tem});

                                if (filterButtons.length != 0) {
                                const listButtons = filterButtons[0].buttons;

                                for (let b = 0; b < listButtons.length; b++) {
                                    const element = listButtons[b];
                                    if (element.type == "URL") {
                                        listButtonsCallToAction.push(element);
                                        if (element.example) {
                                            listButtonsUrlDynamic.push(element);
                                        }
                                    } else if (element.type == "PHONE_NUMBER") {
                                        listButtonsCallToAction.push(element);
                                    } else if (element.type == "QUICK_REPLY") {
                                        listButtonsQuickReply.push(element);
                                    } else if (element.type == "FLOW") {
                                        listButtonsCallToAction.push(element);
                                    }
                                }
                                }
                            } else {
                                if (ext) {
                                    if (ext == "jpg" || ext == "jpeg" || ext == "png") {
                                        formatHeader = "IMAGE"
                                    } else if (ext == "mp4") {
                                        formatHeader = "VIDEO"
                                    } else if (ext == "pdf" || ext == "docx" || ext == "doc" || ext == "csv" || ext == "xlsx" || ext == "txt" || ext == "xls") {
                                        formatHeader = "DOCUMENT"
                                    }
                                }
                                bodyText = "Mensaje tipo plantilla."
                            }
                        }
                    }

                    if (typeMessage === "interactive") {
                        // console.log('-----------------------🚩:', message)
                        const contentInteractive = JSON.parse(message.bodytext)
                        let texOfButton = "";
                        let buttonType = 1;
                        for (let cont of contentInteractive) {
                            if ("header" in cont) {
                                formatHeader = cont.header.type
                                if (formatHeader === "text") {
                                    headerText = cont.header.text
                                }
                            }
                            if ("body" in cont) {
                                bodyTextFlow = cont.body.text
                            }
                            if ("footer" in cont) {
                                footerText = cont.footer.text
                            }
                            if ("button" in cont) {
                                texOfButton = cont.button
                            }
                            if ("interactiveType" in cont) {
                                if (cont.interactiveType == "product_list") {
                                    buttonType = 2
                                }
                            }
                            if ("productsId" in cont) {
                                const filterProduct = listProducts.filter(product => product.retailer_id == cont.productsId[0])
                                imgProduct = filterProduct[0] ? filterProduct[0].image_url : message.bodyMedia
                                numberProducts = cont.productsId.length;
                            }
                            if ("type" in cont) {
                                if (cont.type == "list") {
                                    buttonType = 3
                                } else if (cont.type == "button") {
                                    buttonType = 4
                                } else if (cont.type == "location_request_message") {
                                    buttonType = 5
                                }
                            }
                            if ("buttons" in cont) {
                                buttonsReply = cont.buttons
                            }
                        }

                        let objButton = {}
                        if (buttonType === 2) {
                            objButton.type = "catalog"
                            objButton.text = "Ver artículos"
                        } else if (buttonType === 3) {
                            objButton.type = ""
                            objButton.text = texOfButton
                        } else if (buttonType === 5) {
                            objButton.type = "send_location"
                            objButton.text = "Enviar ubicación"
                        } else {
                            objButton.type = "flow"
                            objButton.text = texOfButton
                        }
                        if (buttonType === 4) {
                            listButtonsQuickReply = buttonsReply;
                        } else {
                            listButtonsCallToAction.push(objButton)
                        }
                    }

                    if (typeMessage === "location") {
                        let objButton = {}
                        objButton.type = "location"
                        objButton.text = "Ver ubicación"
                        listButtonsCallToAction.push(objButton)

                        let dataLocation = message.bodytext.split("||")
                        linkLocation = dataLocation[0]
                        nameLocation = dataLocation[1]
                        if (dataLocation[3]) {
                            linkName = dataLocation[2]
                            adressLocation = dataLocation[3]
                        } else {
                            linkName = dataLocation[0]
                            adressLocation = dataLocation[2]
                        }
                    }

                    if (typeMessage === "contacts") {
                        contactList = JSON.parse(message.bodytext);
                        if (contactList.length > 1) {
                            textContacts = `${contactList[0].name} y ${contactList.length - 1} contactos más`;
                            let objButton = {}
                            objButton.type = "contacts"
                            objButton.text = "Ver todos"
                            listButtonsCallToAction.push(objButton)
                        } else {
                            textContacts = `${contactList[0].name}`;
                        }
                    }

                    if (typeMessage === "order") {
                        const data = JSON.parse(message.bodytext)
                        let totalProducts = 0;
                        let totalPrice = 0;
                        for (let prod of data) {
                            totalProducts = totalProducts + prod.quantity
                            const priceTotalProduct = prod.quantity * prod.item_price
                            totalPrice = totalPrice + priceTotalProduct
                        }
                        numberProducts = totalProducts;
                        headerText = "$ "+totalPrice.toLocaleString('es-CO') + " " + "(total estimado)";

                        const filterProduct = listProducts.find(product => product.retailer_id == data[0].product_retailer_id )
                        imgProduct = filterProduct ? filterProduct.image_url : message.bodyMedia

                        let objButton = {}
                        objButton.type = "none"
                        objButton.text = "Para ver la orden, ve al panel multiagente"
                        listButtonsCallToAction.push(objButton)

                        orderShopping = data;

                    }

                    if (typeMessage === "forwarded") {
                        const msj = JSON.parse(message.bodytext)
                        typeForwarded = msj.type
                        textForwarded = msj.content
                        
                        if (typeForwarded === "contacts") {
                            contactList = msj.contacts;
                            if (contactList.length > 1) {
                                textContacts = `${contactList[0].name} y ${contactList.length - 1} contactos más`;
                                let objButton = {}
                                objButton.type = "contacts"
                                objButton.text = "Ver todos"
                                listButtonsCallToAction.push(objButton)
                            } else {
                                textContacts = `${contactList[0].name}`;
                            }
                        } else if (typeForwarded === "location") {
                            let objButton = {}
                            objButton.type = "location"
                            objButton.text = "Ver ubicación"
                            listButtonsCallToAction.push(objButton)
                            
                            let dataLocation = textForwarded.split("||")
                            linkLocation = dataLocation[0]
                            nameLocation = dataLocation[1]
                            linkName = dataLocation[2]
                            adressLocation = dataLocation[3]
                        }
                    }
                    
                    if (typeMessage === "text") {
                        if (message.bodytext == "Este usuario esta tratando de reenviar un tipo de mensaje que no es soportado actualmente por Whatsapp Business Api. Puedes pedirle al usuario que te envie el mensaje directamente.") {
                            isTextError = true
                        }
                    }
                
                return (
                    <div key={m} id={message._id}>
                        {typeMessage == "warning" ? (
                            <WarningMessage message = {message}/>
                        ) : typeMessage == "transfer" ? (
                            <TransferMessage message={message} />
                        ) : typeMessage == "close_conv" ? (
                            <CloseConvMessage message={message} />
                        ) : (
                            <div className={ message.originMessage === "user" ? "section-div1 ml-2 mr-2" : "section-div1 ml-2 mr-2 text-right"}>
                                <div 
                                    id={`message-${message.messageId}`} 
                                    // className={`section-div2 ${showContactInfo ? 'is-show-info' : ""} ${typeMessage === "groupedImages" ? 'cont-grouped-images' : ""}`} 
                                    className={`section-div2 ${typeMessage === "groupedImages" ? 'cont-grouped-images' : ""}`} 
                                    style={{
                                        maxWidth: typeMessage === "template" || 
                                        typeMessage === "interactive" ? "50%" : 
                                        typeMessage === "video" ? "80%" : 
                                        typeMessage === "groupedImages" ? "40%" :
                                        typeResponseUser == "audio" ? "30%" : "65%",
                                        minWidth: "15rem" 
                                    }}
                                >
                                    <div
                                        className={message.originMessage === "user" ? "section-div3 received" : "section-div3 send"}
                                        style={{background: typeMessage === "sticker" && "transparent", boxShadow: typeMessage === "sticker" && "none"}}
                                        id={typeMessage === "sticker" && "isSticker"}
                                    >
                                        <div className={message.originMessage === "user" ? "section-div4" : "section-div4 text-left"}>
                                            <div
                                                className={typeMessage === "location" ? "section-div5 div5-location pb-0" : typeMessage === "interactive" ? "section-div5 div5-interactive pb-0" : "section-div5 pb-0" }
                                                style={{lineHeight: typeMessage === "contacts" ? "7px" : typeMessage === "sticker" ? "0px" : typeMessage === "contextProduct" ? "10px" : null }}
                                            >
                                                <span className={typeMessage === "text" ? "span message-text" : "span"} style={{lineHeight: typeMessage === "contacts" ? "7px" : typeMessage === "interactive" ? "0px" : null}}>
                                                    {(typeMessage === "image" || typeMessage === "sticker") || (typeMessage === "forwarded" && (typeForwarded === "image" || typeForwarded === "sticker")) ? (
                                                        <div>
                                                            <ImageOrStickerMessage 
                                                                message = {message}
                                                                typeForwarded = {typeForwarded}
                                                                textForwarded = {textForwarded}
                                                                onViewImage = {""}
                                                                // onViewImage = {onViewImage}
                                                                onViewGalery = {""}
                                                                // onViewGalery = {onViewGalery}
                                                                isView = {true}
                                                            />
                                                            {/* {typeMessage === "image" && (
                                                                <div className="py-1">Para abrir la imagen debes ir al multiagente</div>
                                                            )} */}
                                                        </div>
                                                    ) : typeMessage === "location" || (typeMessage === "forwarded" && typeForwarded == "location") ? (
                                                        <LocationOrForwardedMessage
                                                            message = {message}
                                                            linkLocation = {linkLocation}
                                                            imgMap = {imgMap}
                                                            nameLocation = {nameLocation}
                                                            linkName = {linkName}
                                                            adressLocation = {adressLocation}
                                                        />
                                                    ) : typeMessage === "contacts" || (typeMessage === "forwarded" && typeForwarded == "contacts") ? (
                                                        <ContactsOrForwardedMessage 
                                                            message = {message}
                                                            contactList = {contactList}
                                                            setListContacts = {setListContacts}
                                                            setModalListContacts = {setModalListContacts}
                                                            textContacts = {textContacts}
                                                        />
                                                    ) : typeMessage === "video" || (typeMessage === "forwarded" && typeForwarded == "video") ? (
                                                        <VideoOrForwardedMessage 
                                                            message = {message} 
                                                            textForwarded = {textForwarded}
                                                        />
                                                    ) : typeMessage === "document" || (typeMessage === "forwarded" && typeForwarded == "document") ? (
                                                        <DocumentOrForwardedMessage 
                                                            showContactInfo = {showContactInfo}
                                                            message = {message}
                                                            ext = {ext}
                                                            textForwarded = {textForwarded}
                                                        />
                                                    ) : typeMessage === "audio" || (typeMessage === "forwarded" && typeForwarded == "audio") ? (
                                                        <AudioOrForwardedMessage message={message} />
                                                    ) : typeMessage === "template" ? (
                                                        <TemplateMessage
                                                            message = {message}
                                                            formatHeader = {formatHeader}
                                                            headerText = {headerText}
                                                            videoSelected = {videoSelected}
                                                            onViewImage = {onViewImage}
                                                            setLoading = {setLoading}
                                                            listMessages  = {listMessages}
                                                            setListMessages  = {setListMessages}
                                                        />
                                                        // <>Mensaje de Plantilla</>
                                                    ) : typeMessage === "interactive" ? (
                                                        <InteractiveMessage
                                                            message = {message}
                                                            formatHeader = {formatHeader}
                                                            headerText = {headerText}
                                                            imgProduct = {imgProduct}
                                                            showContactInfo = {false}
                                                            // showContactInfo = {showContactInfo}
                                                            numberProducts = {numberProducts}
                                                            ext = {ext}
                                                            bodyTextFlow = {bodyTextFlow}
                                                            onViewImage = {""}
                                                            // onViewImage = {onViewImage}
                                                        />
                                                    ) : typeMessage === "order" ? (
                                                        <OrderMessage
                                                            message = {message}
                                                            headerText = {headerText}
                                                            imgProduct = {imgProduct}
                                                            numberProducts = {numberProducts}
                                                            orderShopping = {orderShopping}
                                                            listProducts = {listProducts}
                                                            formGenerateLink = {formGenerateLink}
                                                            setModalViewOrder = {setModalViewOrder}
                                                            setQuantityOrder = {setQuantityOrder}
                                                            setTotalPriceOrder = {setTotalPriceOrder}
                                                            setOrderSelected = {setOrderSelected}
                                                            isViewOrder = {false}
                                                        />
                                                    ) : typeMessage === "contextProduct" ? (
                                                        <div className="py-3">
                                                            <div><strong>Producto en contexto</strong></div>
                                                            <div className="py-1">Para ver este tipo de mensaje debes ir al panel multiagente</div>
                                                        </div>
                                                    ) : typeMessage === "contextText" ? (
                                                        <div className="py-3">
                                                            <div><strong>Texto en contexto</strong></div>
                                                            <div className="py-1">Para ver este tipo de mensaje debes ir al panel multiagente</div>
                                                        </div>
                                                        
                                                    ) : typeMessage === "forwarded" ? (
                                                        <ForwardedMessage textForwarded = {textForwarded}/>
                                                    ) : typeMessage === "groupedImages" ? (
                                                        <GroupedImages 
                                                            message = {message}
                                                            onViewGalery = {onViewGalery}
                                                        />
                                                    ) : typeMessage === "advertising" ? (
                                                        <div className="py-3">
                                                            <div><strong>Respuesta de publicidad</strong></div>
                                                            <div className="py-1">Para ver este tipo de mensaje debes ir al panel multiagente</div>
                                                        </div>
                                                    ) : typeMessage === "transfer" ? (
                                                        <span style={{ color: "#5bc0de"}}>{message.bodytext}</span>
                                                    ) : (
                                                        <TextMessage message={message} isTextError={isTextError}/>
                                                    )}
                                                </span>
                                            </div>
                                            
                                            <FooterMessage message={message} footerText={footerText} showTooltip = {true} />
                
                                            {typeMessage === "image" || typeMessage === "video" ? (
                                                <a href={message.bodyMedia} target="_blank" download="sendingup-image.jpg" rel="noreferrer">
                                                    <span id="downOpen" className="pointer" title="Descargar" onClick={(e) => e.stopPropagation()}>
                                                        <IoMdDownload style={{fontSize: "1.8rem"}}/>
                                                    </span>
                                                </a>
                                            ) : null}
                
                                        </div>
                
                                        {/* LISTA DE BOTONES DE LLAMADA A LA ACCIÓN */}
                                        {listButtonsCallToAction && listButtonsCallToAction.map((btn, b) => (
                                            <ListButtonsCallToAction 
                                                b = {b}
                                                btn = {btn}
                                                message = {message}
                                                contactList = {contactList}
                                                orderShopping = {orderShopping}
                                                ProductInContext = {ProductInContext}
                                                listProducts = {listProducts}
                                                urlAdvertising = {urlAdvertising}
                                                linkLocation = {linkLocation}
                                                setListContacts = {setListContacts}
                                                setModalListContacts = {setModalListContacts}
                                                setModalViewProductContext = {false}
                                                setProductContextSelected = {setProductContextSelected}
                                                setModalViewOrder = {setModalViewOrder}
                                                setQuantityOrder = {setQuantityOrder}
                                                setTotalPriceOrder = {setTotalPriceOrder}
                                                setOrderSelected = {setOrderSelected}
                                                setLoading = {false}
                                                formGenerateLink = {formGenerateLink}
                                            />
                                        ))}
                
                                    </div>
                
                                    {/* LISTA DE BOTONES DE RESPUESTA RAPIDA */}
                                    {listButtonsQuickReply && listButtonsQuickReply.map((btn, b) => (
                                        <div key={b} className="content-fastAnswer message">
                                            <div>
                                                <span>{btn.text}</span>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                )})}
            </section>
            
            {isGallery && (
                <ImageGallery 
                    imgSelected = {imgSelected}
                    listImages = {listImages}
                    setIsGallery = {setIsGallery}
                    setImgSelected = {setImgSelected}
                />
            )}

            {/* Modal para mostrar contactos enviados por el cliente */}
            <Modal
            status={modalListContacts}
            changeStatus={setModalListContacts}
            title= {listContacts.length > 1 ? `${listContacts.length} contactos` : "Ver contacto"}
            width={"460px"}
            >
            <Content>
                <form style={{ width: "100%" }}>
                <div>
                    <div
                    className="content-list-contacts su-control mt-2 text-center"
                    style={{overflow: "auto", height: "50vh"}}
                    >
                    <ul>
                        {listContacts?.map((contact, c) => (
                        <li key={c}>
                            <div className="d-flex align-items-center">
                            <div className="ml-1" style={{border: "2px solid", borderRadius: "50%", backgroundColor: "#6a7175"}}>
                                <FaUser style={{margin: "7px", fontSize: "2rem"}}/>
                            </div>
                            <div className="ml-3 pointer text-left">
                                <p id="name-contact">
                                {contact.name}
                                </p>
                                <p>
                                {contact.phone}
                                </p>
                            </div>
                            </div>
                        </li>
                        ))}
                    </ul>
                    </div>
                </div>

                <div className="row justify-content-end bd col-12 mt-4">
                    <a
                    href="javascript:;"
                    className="btn btn-lg btn-default mr-1"
                    onClick={() => {
                        setModalListContacts((prevMessage) => { return false});
                    }}
                    >
                    Cerrar
                    </a>
                </div>
                </form>


            </Content>
            </Modal>

            {/* Modal para mostrar orden enviada por el cliente */}
            <Modal
                status={modalViewOrder}
                changeStatus={setModalViewOrder}
                title="Detalles de la orden"
                width={"500px"}
            >
                <Content>
                    <form style={{ width: "100%" }}>
                        <div>
                            <div>
                                <div>
                                <h5 className="mb-0">{quantityOrder > 1 ? `${quantityOrder} elementos` : `${quantityOrder} elemento`}</h5>
                                </div>
                                <div>
                                <span className="span-color">$ {totalPriceOrder.toLocaleString('es-CO')} (estimado)</span>
                                </div>
                            </div>

                            <div
                                className="content-list-contacts su-control mt-2 text-center"
                                style={{overflow: "auto", height: "50vh"}}
                            >
                                <ul>
                                {orderSelected.map(product => (
                                <li>
                                    <div className="d-flex align-items-center">
                                    <div className="col-4">
                                        <img className="w-100" style={{height:"5rem", objectFit:"contain"}} src={product.image_url}/>
                                    </div>
                                    <div className="col-8 text-left">
                                        <div>
                                        <h5 className="mb-0">{product.name}</h5>
                                        </div>
                                        <div>
                                        <span className="span-color">{product.price} - Cantidad: {product.quantity}</span>
                                        </div>
                                    </div>
                                    </div>
                                </li>
                                ))}
                                </ul>
                            </div>
                        </div>

                        <div className="row justify-content-center bd mt-4">
                            <input
                                className="btn btn-lg btn-info"
                                type="button"
                                value="Generar link de pago"
                                onClick={() => {
                                setModalViewOrder(false);
                                }}
                            />
                        </div>
                    </form>
                </Content>
            </Modal>
        </>
    );
};

export default MessageList;

const Content = styled .div`
    display: flex;
    flex-direction: column;
    align-items: center;
    h1 {
        font-size: 42px;
        font-weight: 700;
        margin-bottom: 10px;
        text-align: center;
    }
    li {
        padding: 10px 5px;
        border-bottom: 1px solid rgb(0, 0, 0, 0.05);
    }
    li:hover {
        background: rgb(0, 0, 0, 0.05);
    }
    p {
        font-size: 18px;
        margin-bottom: 0px;
    }
    input {
        padding: 10px;
        border-radius: 0px;
        font-size: 17px;
    }
    img.img-answer {
        cursor: pointer;
        width: auto;
        height: 85px;
        object-fit: scale-down;
    }
    .content-img {
        position: relative;
    }
    .content-img img:hover {
        opacity: 0.6;
    }
`;
